import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { PublicLayout } from "@/components/PublicLayout";
import api from "@/lib/api";
import { ShareServiceButton } from "@/components/ShareServiceButton";

export default function Services() {
    const [settings, setSettings] = useState(null);
    const [services, setServices] = useState([]);

    useEffect(() => {
        api.get("/settings").then((r) => setSettings(r.data));
        api.get("/services").then((r) => setServices(r.data));
    }, []);

    return (
        <PublicLayout settings={settings}>
            <section className="max-w-6xl mx-auto px-6 py-16">
                <div className="font-mono text-xs uppercase tracking-[0.25em] text-[hsl(var(--muted-foreground))]">Services</div>
                <h1 className="font-display text-4xl sm:text-5xl mt-3">What we can help you with.</h1>
                <p className="mt-4 max-w-2xl text-[hsl(var(--muted-foreground))]">
                    Choose a service that matches where you are. Book instantly on our live calendar.
                </p>

                <div className="mt-12 grid md:grid-cols-2 gap-6">
                    {services.map((s) => (
                        <div key={s.id} className="card-clay p-6 flex flex-col" data-testid={`service-item-${s.id}`}>
                            <div className="flex items-center justify-between">
                                <div className="font-mono text-[10px] uppercase tracking-widest text-[hsl(var(--muted-foreground))]">
                                    {s.is_paid ? "Paid" : "Free"} · {s.duration_min} min
                                </div>
                                {s.is_paid ? (
                                    <div className="font-mono text-sm bg-[hsl(var(--secondary))] px-3 py-1 rounded">
                                        ${s.price} {s.currency}
                                    </div>
                                ) : (
                                    <div className="font-mono text-xs px-3 py-1 rounded bg-[hsl(var(--accent))] text-white">
                                        Free
                                    </div>
                                )}
                            </div>
                            <h3 className="font-display text-2xl mt-4">{s.title}</h3>
                            <p className="mt-2 text-sm text-[hsl(var(--muted-foreground))] flex-1">{s.description}</p>
                            {s.is_paid && (
                                <div className="mt-3 text-xs text-[hsl(var(--muted-foreground))]">
                                    Payment coming soon — book now, pay when we set up online payments.
                                </div>
                            )}
                            <div className="mt-5 flex items-center gap-3">
                                <Link to={`/book?service=${s.id}`} data-testid={`book-service-${s.id}`} className="pill btn-primary px-5 py-2 text-sm font-medium">
                                    Book this service
                                </Link>
                                <ShareServiceButton service={s} />
                            </div>
                        </div>
                    ))}
                    {services.length === 0 && (
                        <div className="text-[hsl(var(--muted-foreground))]">No services yet — check back soon.</div>
                    )}
                </div>
            </section>
        </PublicLayout>
    );
}
